/*
 * sections/index.js  —  Engine E section-component registry (global registration).
 * Purpose: Vue.component()-register the four report section renderers under their
 *   VERBATIM kebab names so ReportViewScreen's
 *   <component :is="section2cmp[type] || 'report-section-not-found'"> resolves by
 *   string. Registration is idempotent (safe to import from multiple entry points).
 *
 * reconstructed from lacak.io deployed behavior; app-specific contract verbatim,
 * internal impl re-authored.
 *
 * VERBATIM kebab names (ad4f.js section2cmp + fallback):
 *   report-section-table, report-section-text, report-section-xy-graph,
 *   report-section-not-found
 */

import Vue from 'vue';

import ReportSectionTable from './ReportSectionTable.vue';
import ReportSectionText from './ReportSectionText.vue';
import ReportSectionXyGraph from './ReportSectionXyGraph.vue';
import ReportSectionNotFound from './ReportSectionNotFound.vue';

// Map of the kebab names used in section2cmp -> component definitions.
export const SECTION_COMPONENTS = {
  'report-section-table': ReportSectionTable,
  'report-section-text': ReportSectionText,
  'report-section-xy-graph': ReportSectionXyGraph,
  'report-section-not-found': ReportSectionNotFound,
};

let registered = false;

// Idempotently register every section component globally on the given Vue.
export function registerReportSections(vue) {
  const target = vue || Vue;
  if (registered) return;
  Object.keys(SECTION_COMPONENTS).forEach((name) => {
    target.component(name, SECTION_COMPONENTS[name]);
  });
  registered = true;
}

// Auto-register on import so a simple `import './sections/index.js'` is enough.
registerReportSections(Vue);

export default registerReportSections;
